import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=74ea232d&scoped=true&lang=pug&"
import script from "./Performance.vue?vue&type=script&lang=js&"
export * from "./Performance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea232d",
  null
  
)

export default component.exports